// src/apollo/client.js
import {ApolloClient, InMemoryCache, ApolloProvider, createHttpLink, ApolloLink, Observable} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { handleTokenExpiration, ReIssuanceAccessToken } from "../utils/auth";
import { handlePermissionErrors } from "../utils/errorHandler";

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const GRAPHQL_URL = isLocalhost ? 'http://localhost:8080/graphql' : '/graphql';

// 오류 처리 및 재시도
const retryOnUnauthorizedLink = new ApolloLink((operation, forward) => {
    return new Observable(observer => {
        const subscriber = {
            next: async result => {
                // 권한 에러 체크 및 처리
                const hasPermissionError = await handlePermissionErrors(result?.errors);
                
                if (hasPermissionError) {
                    observer.next(null);
                    observer.complete();
                    return;
                }
                
                observer.next(result);
            },
            error: async networkError => {
                const response = networkError?.result;
                const code = response?.errors?.[0]?.extensions?.code || response?.code;

                if (networkError?.statusCode === 401 && code === "T001") {
                    // 반드시 await 사용!
                    const success = await ReIssuanceAccessToken();

                    if (success) {
                        // 재시도
                        forward(operation).subscribe(observer);
                        return;
                    }
                }

                if (networkError?.statusCode === 401 && code === "T002") {
                    await handleTokenExpiration();
                }

                observer.error(networkError);
            },
            complete: () => observer.complete(),
        };

        forward(operation).subscribe(subscriber);
    });
});

const httpLink = createHttpLink({
    uri: GRAPHQL_URL,
    credentials: 'include' // CORS 설정
});

// 인증 헤더 추가
const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            // authorization: token ? `Bearer ${token}` : "",
        }
    };
});

export const client = new ApolloClient({
    link: retryOnUnauthorizedLink.concat(authLink.concat(httpLink)),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
    }
});

export { ApolloProvider };